import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";

function Template({ formType }) {
  const { loading } = useSelector((state) => state.auth);

  return (
    <div className="min-h-[calc(100vh-3.5rem)] flex bg-richblack-900">
      <div className="flex flex-1 items-center justify-center p-6 sm:p-10 lg:p-16">
        {loading ? (
          <div className="spinner" />
        ) : (
          <div className="w-full max-w-[440px]">
            <div className="rounded-2xl border border-richblack-700 bg-richblack-800 p-8 shadow-[0_20px_60px_rgba(0,0,8,0.45)]">
              {formType === "signup" ? <SignupForm /> : <LoginForm />}
            </div>

            <p className="mt-6 text-center text-xs text-richblack-500">
              By continuing, you agree to our{" "}
              <Link
                to="/terms"
                className="text-richblack-400 underline transition-colors hover:text-richblack-200"
              >
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link
                to="/privacy-policy"
                className="text-richblack-400 underline transition-colors hover:text-richblack-200"
              >
                Privacy Policy
              </Link>
              .
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Template;
